import React from "react";
import nextId from "react-id-generator";
import { contactUsAPI } from "../../APIs/PostAPIS";
import { Images } from "../../Assets/0a-exporter";
import CommonFooter from "../LandingPage/CommonFooter/CommonFooter";
import LandingHeader from "../LandingPage/LandingHeader/LandingHeader";
import Notification from "../Portals/Notification/Notification";
import CandidateForm from "./CandidateForm/CandidateForm";
import "./contact-page.style.scss";
import InstituteForm from "./InstituteForm/InstituteForm";
export default function ContactPage() {
  const [selectedOption, setSelectedOption] = React.useState(options[0]);
  const [loading, setLoading] = React.useState(false);
  const [countryCode, setCountryCode] = React.useState("+91");
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [details, setDetails] = React.useState({
    contact_type: "",
    contact_person: "",
    full_name: "",
    email: "",
    mobile: "",
    topic: "",
    comments: "",
  });
  const createContact = async () => {
    setLoading(true);
    let temp = {
      ...details,
      mobile: countryCode + "-" + details.mobile,
      contact_type: selectedOption.id.toUpperCase(),
    };
    let res = await contactUsAPI(temp);
    if (res.data.data) {
      setNotification({
        status: true,
        title: "We will contact you soon",
      });
      setDetails({
        contact_type: "",
        contact_person: "",
        full_name: "",
        email: "",
        mobile: "",
        topic: "",
        comments: "",
      });
      setLoading(false);
    } else {
      setNotification({
        status: true,
        title: res.data.message,
      });
      setLoading(false);
    }
  };
  return (
    <div className="contact-page-main">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <LandingHeader opaque="opaque" help={true} />
      <div className="cpm-title">
        <h2>Contact Us</h2>
        <div className="lcm-options">
          <div
            className={
              selectedOption.id === "candidate" ? "left-most" : "right-most"
            }
          />
          {options.map((obj) => (
            <h6
              onClick={() => setSelectedOption(obj)}
              className={obj.id === selectedOption.id ? "selected" : ""}
              key={obj.keyId}
            >
              {obj.text}
            </h6>
          ))}
        </div>
      </div>
      <div className="cpm-body">
        <div className="cpmb-left">
          {[1, 2].map((obj) => (
            <div className="address-card">
              <div className="ac-title">
                <h5>INDIA</h5>
              </div>
              <div className="ac-other">
                <p>
                  <img src={Images.blueLocation} />
                  {obj === 2
                    ? "No. 2, Musaffah Shabiya,SectorME 12,Abu Dhabi,UAE"
                    : "#190, BEML Layout, Bengaluru, Karnataka, India"}
                </p>
                <p>
                  <img src={Images.callLogo} />
                  {obj === 2 ? "+971 50 766 1376" : "+91 91488 81795"}
                </p>
                <p>
                  <img src={Images.email} />
                  contact@acadshr.com
                </p>
                <p>
                  <img src={Images.stopWatchLogo} />9 AM IST - 6 PM IST (Monday
                  - Friday)
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="cpmb-right">
          {/* <CandidateForm /> */}
          {/* <InstituteForm /> */}
          {selectedOption.id === "candidate" ? (
            <CandidateForm
              setDetails={setDetails}
              details={details}
              createContact={createContact}
              loading={loading}
              setCountryCode={setCountryCode}
              countryCode={countryCode}
            />
          ) : (
            <InstituteForm
              setDetails={setDetails}
              details={details}
              createContact={createContact}
              loading={loading}
              setCountryCode={setCountryCode}
              countryCode={countryCode}
            />
          )}
        </div>
      </div>
      <CommonFooter />
    </div>
  );
}
const options = [
  { keyId: nextId(), id: "candidate", text: "For Candidates" },
  { keyId: nextId(), id: "institute", text: "For Institutes" },
];
